import { apiClientV2 } from '@/services/rest-api/apiClient'
const baseURL = process.env.VUE_APP_API_FINANCIAL_RECORD_URL

export const getList = async (page, limit, search, sorts) => {
  const params = {
    limit: limit,
    page: page,
    sorts: sorts,
    search: search,
    filters: undefined,
  }

  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: '/template',
    params: params,
  })

  return response?.data
}

export const show = async (id) => {
  const response = await apiClientV2({
    method: 'GET',
    baseURL,
    url: `/template/${id}`,
  })

  return response?.data
}